import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  EmpresaFormValue,
  EmpresasDataModel,
  EmpresasInfoModel,
} from '../models/empresa.data.model';
import { map, Observable } from 'rxjs';
import { ApiResponse } from '../models/api.model';
import { API_URL } from '../config/api.config';
import {
  PagedResponse,
  PaginationRequest,
} from '../../shared/data-table-paginado/data-table-paginado.models';

@Injectable({ providedIn: 'root' })
export class EmpresaService {
  private readonly http = inject(HttpClient);
  private readonly resourceUrl = `${API_URL}/empresa`;

  getEmpresasInfo(): Observable<EmpresasInfoModel | null> {
    return this.http
      .get<ApiResponse<EmpresasInfoModel>>(`${this.resourceUrl}/informacion`)
      .pipe(map((response) => response.data));
  }

  getEmpresasDataPaginada(
    request: PaginationRequest,
  ): Observable<ApiResponse<PagedResponse<EmpresasDataModel>>> {
    let params = new HttpParams().set('page', request.page).set('pageSize', request.pageSize);

    if (request.search?.trim()) {
      params = params.set('search', request.search.trim());
    }
    if (request.status) {
      params = params.set('status', request.status);
    }

    if (request.sortBy) {
      params = params.set('sortBy', request.sortBy);
    }

    if (request.sortDirection) {
      params = params.set('sortDirection', request.sortDirection);
    }

    return this.http.get<ApiResponse<PagedResponse<EmpresasDataModel>>>(
      `${this.resourceUrl}/paginado`,
      { params },
    );
  }

  create(request: EmpresaFormValue): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.resourceUrl}/create`, request);
  }

  update(idEmpresa: string, request: EmpresaFormValue): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.resourceUrl}/update/${idEmpresa}`, request);
  }

  desactivate(id: string): Observable<ApiResponse<boolean>> {
    return this.http.put<ApiResponse<boolean>>(`${this.resourceUrl}/desactivate/${id}`, null);
  }

  getAll(): Observable<EmpresasDataModel[]> {
    return this.http
      .get<ApiResponse<EmpresasDataModel[]>>(this.resourceUrl)
      .pipe(map((response) => response.data ?? []));
  }
}
